import { formatMoney } from './novicell_shopify-utility.js';

(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const productId = window.productId;
    const handle = window.productHandle;
    const moneyFormat = window.shopMoneyFormat;
    const shopCurrency = window.shopCurrency;
    const upsellContainer = document.getElementById("upsell-container");

    function initializeUpsellDrawerOptionEvents() {
      const optionSections = document.querySelectorAll('.upsell-drawer-material-selects-switch');

      optionSections.forEach(section => {
        const clickableElems = section.querySelectorAll('label, img');
        const valueSpan = section.querySelector('.seleceted-option-value');

        if (clickableElems.length > 0) {
          const firstElem = clickableElems[0];
          firstElem.classList.add('active');
          if (valueSpan) {
            valueSpan.textContent = firstElem.getAttribute('data-option-value-name');
          }
        }

        clickableElems.forEach(elem => {
          elem.addEventListener('click', () => {
            clickableElems.forEach(i => i.classList.remove('active'));
            elem.classList.add('active');

            if (valueSpan) {
              valueSpan.textContent = elem.getAttribute('data-option-value-name');
            }

            const selectedOptions_ = [];
            optionSections.forEach(sec => {
              const span = sec.querySelector('.seleceted-option-value');
              if (span) {
                const value = span.textContent.trim();
                if (value) selectedOptions_.push(value);
              }
            });

            const matchedVariant = window.upsellProduct.variants.find(variant => {
              return selectedOptions_.every((opt, index) => {
                return opt === variant[`option${index + 1}`];
              });
            });

            const priceLoweredElem = document.querySelector('.upsell-drawer-price-lowered');
            const priceRegularElem = document.querySelector('.upsell-drawer-price-regular');

            if (priceLoweredElem) {
              priceLoweredElem.textContent = formatMoney(matchedVariant.price, moneyFormat).replace(/,/g, '.');
            }

            if (priceRegularElem) {
              if (matchedVariant.price_max && matchedVariant.price_max > matchedVariant.price) {
                //priceRegularElem.textContent = formatMoney(matchedVariant.price_max, moneyFormat).replace(/,/g, '.');
              } else {
                if (window.upsellProduct.price_max > matchedVariant.price) {
                  //priceRegularElem.textContent = formatMoney(window.upsellProduct.price_max, moneyFormat).replace(/,/g, '.');
                } else {
                  priceRegularElem.textContent = '';
                }

              }
            }

            const priceSpan = document.querySelector('#upsell-drawer-add-to-cart span');
            if (priceSpan) {
              priceSpan.textContent = formatMoney(matchedVariant.price, moneyFormat);
            }

            document.getElementById('upsell-drawer-add-to-cart').setAttribute('data-product-id', matchedVariant.id);

            const selectedOptions = [];
            optionSections.forEach(sec => {
              const span = sec.querySelector('.seleceted-option-value');
              if (span) {
                const value = span.textContent.trim();
                if (value) selectedOptions.push(value);
              }
            });

            const galleryImages = document.querySelectorAll('.scroll-container img');
            let matchedImage = null;

            galleryImages.forEach(galleryImg => {
              const opt1 = galleryImg.getAttribute('option1') || '';
              const opt2 = galleryImg.getAttribute('option2') || '';
              const opt3 = galleryImg.getAttribute('option3') || '';
              const options = [opt1, opt2, opt3];

              const isMatch = selectedOptions.every(opt => options.includes(opt));
              if (isMatch) {
                matchedImage = galleryImg;
              }
            });

            if (matchedImage) {
              matchedImage.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }

            const url = `${window.location.origin}/products/${window.upsellProduct.handle}?variant=${matchedVariant.id}`;

            fetch(url)
              .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text();
              })
              .then(htmlString => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, 'text/html');
                const stockStatus = doc.querySelector('stock-status');

                if (stockStatus) {
                  const deliveryEl = document.querySelector('.upsell-drawer-delivery');
                  if (deliveryEl) {
                    deliveryEl.innerHTML = stockStatus.innerHTML;
                  }
                }
              })
              .catch(error => {
                console.error('Error:', error);
              });
          });
        });
      });
    }

    // Function to display the upsell product details on the page.
    function displayUpsellProduct(product) {

      window.upsellProduct = product;

      //UPSELL DRAWER START

      //UPSELL DRAWER GALLERY
      const imagesHtml = product.images.map(image => {
        let option1 = "";
        let option2 = "";
        let option3 = "";

        for (const variant of product.variants) {
          if (variant.featured_image != null) {
            variant.featured_image.src = variant.featured_image.src.replace(/^https:/, '');
          }

          if (variant.featured_image != null && variant.featured_image.src === image) {
            option1 = variant.option1 || "";
            option2 = variant.option2 || "";
            option3 = variant.option3 || "";
            break;
          }
        }

        return `<img src="${image}&width=308" option1="${option1}" option2="${option2}" option3="${option3}" alt="">`;
      }).join("");

      const container = document.querySelector('.upsell-gallery-body');
      if (container) {
        container.innerHTML = imagesHtml;
      }

      //UPSELL DRAWER TITLE
      const primaryTitleElem = document.querySelector('.upsell-primary-title');
      const secondaryTitleElem = document.querySelector('.upsell-secondary-title');

      if (product.title) {
        const escapedTitle = product.title
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");

        const parts = escapedTitle.split(',');
        const primary = parts[0].trim();
        const secondary = parts.length > 1 ? parts.slice(1).join(',').trim() : "";

        if (primaryTitleElem) primaryTitleElem.textContent = primary;
        if (secondaryTitleElem) secondaryTitleElem.textContent = secondary;
      }

      //UPSELL DRAWER PRICES
      const priceLoweredElem = document.querySelector('.upsell-drawer-price-lowered');
      const priceRegularElem = document.querySelector('.upsell-drawer-price-regular');

      if (priceLoweredElem) {
        priceLoweredElem.textContent = formatMoney(product.price, moneyFormat).replace(/,/g, '.');
      }

      if (priceRegularElem) {
        if (product.price_max && product.price_max > product.price) {
          //priceRegularElem.textContent = formatMoney(product.price_max, moneyFormat).replace(/,/g, '.');
        } else {
          if (window.upsellProduct.price_max > matchedVariant.price) {
            //priceRegularElem.textContent = formatMoney(window.upsellProduct.price_max, moneyFormat).replace(/,/g, '.');
          } else {
            priceRegularElem.textContent = '';
          }
        }
      }

      //UPSELL DRAWER VENDOR
      const vendorSpan = document.querySelector('.upsell-drawer-designer span.upsell-drawer-designer-span');
      if (vendorSpan) {
        vendorSpan.textContent = product.vendor || '';
      }

      const optionsWrapper = document.querySelector('.upsell-drawer-material-selects');
      if (optionsWrapper && product.options) {
        optionsWrapper.innerHTML = '';

        // Create template in JS (not in HTML)
        const template = document.createElement('template');
        template.innerHTML = `
        <div class="upsell-drawer-material-selects-switch tw-font-secondary tw-mr-16">
          <p class="tw-mb-3">
            <span class="option-name"></span>:<span class="seleceted-option-value tw-font-normal tw-font-primary tw-leading-normal"></span>
          </p>
          <div class="upsell-drawer-material-selects-options tw-flex tw-flex-wrap"></div>
        </div>
        `;

        product.options.forEach(option => {
          // Clone template content
          const switchDiv = template.content.cloneNode(true);

          // Set option name
          switchDiv.querySelector('.option-name').textContent = option.name;

          // Find options container inside the clone
          const optionsContainer = switchDiv.querySelector('.upsell-drawer-material-selects-options');

          option.values.forEach((value) => {
            const basePath = "/cdn/shop/files/";

            const valueNormalized = value.normalize("NFD")
              .toLowerCase()
              .replace(/\s*\|\s*/g, '-')
              .replace(/\s+/g, '-')
              .replace(/[^a-z0-9\-]/g, '');

            const filename1Base = valueNormalized;
            const filename2Base = value.normalize("NFD")
              .replace(/\s+/g, '-')
              .replace(/[^a-z0-9\-]/gi, '');

            const formats = ['jpg', 'jpeg', 'png', 'webp', 'gif'];

            const img = document.createElement('img');
            img.className = 'tw-object-fill tw-cursor-pointer tw-border-0 tw-border-transparent tw-p-0 tw-transition-colors tw-duration-200 tw-ease-in-out tw-mr-3 tw-mb-3';
            img.alt = value;
            img.setAttribute('data-option-value-name', value);

            async function checkImageExists(url) {
              return new Promise((resolve) => {
                const tester = new Image();
                tester.onload = () => resolve(true);
                tester.onerror = () => resolve(false);
                tester.src = url;
              });
            }

            function replaceImgWithLabel() {
              const label = document.createElement('label');
              label.textContent = value;
              label.setAttribute('data-option-value-name', value);
              label.setAttribute('class', 'tw-mr-3 tw-mb-3 tw-text-sm tw-text-center tw-cursor-pointer');
              img.replaceWith(label);
              initializeUpsellDrawerOptionEvents();
            }

            async function setImageOrLabel() {
              for (const ext of formats) {
                const url1 = basePath + `${filename1Base}.${ext}`;
                const url2 = basePath + `${filename2Base}.${ext}`;

                if (await checkImageExists(url1)) {
                  img.src = url1;
                  break;
                } else if (await checkImageExists(url2)) {
                  img.src = url2;
                  break;
                }
              }

              if (!img.src) {
                replaceImgWithLabel();
              }
            }

            setImageOrLabel();

            optionsContainer.appendChild(img);
          });

          optionsWrapper.appendChild(switchDiv);
        });
      }


      //UPSELL DRAWER DESCRIPTION
      const descriptionWrapper = document.querySelector('.upsell-drawer-product-description');

      if (descriptionWrapper) {
        const linkElement = descriptionWrapper.querySelector('#see-full-product');

        if (linkElement) {
          const descEl = document.createElement('div');
          descEl.innerHTML = product.description || '';

          descriptionWrapper.insertBefore(descEl, linkElement);

          linkElement.setAttribute('href', '/products/' + product.handle);
        }
      }

      //UPSELL DRAWER BUTTON PRICE
      const priceSpan = document.querySelector('#upsell-drawer-add-to-cart span');
      if (priceSpan) {
        priceSpan.textContent = formatMoney(product.price, moneyFormat);
      }

      //UPSELL DRAWER END

      const upsellImage = document.getElementById("upsell-image")
      if (upsellImage) {
        upsellImage.src = product.featured_image || ""
        upsellImage.alt = product.title || ""
      }
      const upsellTitle = document.getElementById("upsell-title")
      if (upsellTitle) upsellTitle.textContent = product.title || ""
      const upsellVariant = document.getElementById("upsell-variant")
      if (upsellVariant) {
        if (product.variants && product.variants.length > 0)
          upsellVariant.textContent = product.variants[0].title || "Default"
        else upsellVariant.textContent = "Default"
      }
      const upsellPrice = document.getElementById("upsell-price");
      if (upsellPrice) {
        const formattedPrice = formatMoney(product.price, moneyFormat);
        upsellPrice.innerHTML = formattedPrice;
      }
      const upsellBlock = document.getElementById("upsell-container")
      if (upsellBlock) {
        upsellBlock.style.display = "block"
        upsellBlock.style.visibility = "visible"
      }
      const addToCartBtn = document.getElementById("add-to-cart-btn")
      if (addToCartBtn) {
        if (product.variants && product.variants.length > 0) {
          const variantId = product.variants[0].id
          addToCartBtn.setAttribute("data-product-id", variantId)
          addToCartBtn.style.display = "inline-block"
        } else {
          addToCartBtn.setAttribute("data-product-id", "")
          addToCartBtn.style.display = "none"
        }
      }

      const addToCartBtn2 = document.getElementById("upsell-drawer-add-to-cart")
      if (addToCartBtn2) {
        if (product.variants && product.variants.length > 0) {
          const variantId = product.variants[0].id
          addToCartBtn2.setAttribute("data-product-id", variantId)
          addToCartBtn2.style.display = "flex"
        } else {
          addToCartBtn2.setAttribute("data-product-id", "")
          addToCartBtn2.style.display = "none"
        }
      }
      const upsellLink = document.getElementById("product-upsell-link")
      if (upsellLink && product.handle) {
        upsellLink.setAttribute("href", `/products/${product.handle}`)
      }

      // INITIAL FETCH DELIVERY
      const url = `${window.location.origin}/products/${product.handle}`;

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(htmlString => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          const stockStatus = doc.querySelector('stock-status');

          if (stockStatus) {
            const deliveryEl = document.querySelector('.upsell-drawer-delivery');
            if (deliveryEl) {
              deliveryEl.innerHTML = stockStatus.innerHTML;
            }
          } else {
            console.log('<stock-status> element not found.');
          }
        })
        .catch(error => {
          console.error('Fetch error:', error);
        });

      if (typeof initializeUpsellDrawerOptionEvents === 'function') {
        initializeUpsellDrawerOptionEvents();
      }
    }

    // Hide the upsell block
    function hideUpsellBlock() {
      if (upsellContainer) {
        upsellContainer.style.display = "none";
        upsellContainer.style.visibility = "hidden";
      }
    }


    // Fetches product recommendations from Shopify's API.
    fetch(`/recommendations/products.json?product_id=${productId}&intent=complementary&limit=1`)
      .then((res) => res.json())
      .then((data) => {
        if (data.products && data.products.length > 0) {
          displayUpsellProduct(data.products[0]);
        } else {
          hideUpsellBlock();
        }
      })
      .catch((error) => {
        console.error("Error fetching complementary products:", error);
        hideUpsellBlock();
      });
  });


  // Event listener for click events, specifically targeting button with the 'upsell-add-item-to-cart' class.
  document.addEventListener("click", (event) => {
    const button = event.target.closest(".upsell-add-item-to-cart")
    if (!button) return
    event.preventDefault()
    if (button.disabled) return
    button.disabled = true
    const variantId = button.getAttribute("data-product-id")
    if (!variantId) {
      button.disabled = false
      document.getElementById('upsell-drawer')?.classList.remove('active');
      return
    }
    ; (async () => {
      try {
        const addResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: Number.parseInt(variantId, 10), quantity: 1 }),
        })
        if (!addResponse.ok) {
          const errorData = await addResponse.json()
          throw new Error(`Error adding product: ${errorData.description || addResponse.statusText}`)
        }
        await addResponse.json()
        await refreshCartDrawerHTML()
        await updateCartIconBubble()
      } catch (error) {
        console.error("Error:", error)
      } finally {
        button.disabled = false
        document.getElementById('upsell-drawer')?.classList.remove('active');
      }
    })()
  })

  // Asynchronous function to refresh the HTML content of the cart drawer.
  async function refreshCartDrawerHTML() {
    try {
      const sectionsResponse = await fetch(`/?section_id=cart-drawer&timestamp=${Date.now()}`, {
        headers: { Accept: "text/html", "Cache-Control": "no-cache" },
      })
      if (!sectionsResponse.ok) throw new Error(`Sections fetch error: ${sectionsResponse.status}`)
      const newHTML = await sectionsResponse.text()
      const currentCartDrawer = document.querySelector("cart-drawer")
      if (!currentCartDrawer) return
      const tempDiv = document.createElement("div")
      tempDiv.innerHTML = newHTML
      const newCartDrawer = tempDiv.querySelector("cart-drawer")
      if (!newCartDrawer) return
      currentCartDrawer.innerHTML = newCartDrawer.innerHTML
      Array.from(newCartDrawer.attributes).forEach((attr) => {
        if (attr.name !== "id") currentCartDrawer.setAttribute(attr.name, attr.value)
      })
      if (typeof currentCartDrawer.open === "function") currentCartDrawer.open()
      else {
        currentCartDrawer.classList.add("active")
        currentCartDrawer.setAttribute("open", "")
      }
      await updateCartIconBubble()
    } catch {
      await fallbackSectionsUpdate()
    }
  }

  // Asynchronous fallback function to update cart sections if the primary refresh fails.
  async function fallbackSectionsUpdate() {
    try {
      const sectionsResponse = await fetch(`/?sections=cart-drawer,cart-icon-bubble&timestamp=${Date.now()}`, {
        headers: { Accept: "application/json", "Cache-Control": "no-cache" },
      })
      if (!sectionsResponse.ok) throw new Error(`Fallback fetch error: ${sectionsResponse.status}`)
      const sectionsData = await sectionsResponse.json()
      if (sectionsData["cart-drawer"]) {
        const cartDrawer = document.querySelector("cart-drawer")
        if (cartDrawer) {
          cartDrawer.innerHTML = sectionsData["cart-drawer"]
          if (typeof cartDrawer.open === "function") cartDrawer.open()
          else {
            cartDrawer.classList.add("active")
            cartDrawer.setAttribute("open", "")
          }
        }
      }
      if (sectionsData["cart-icon-bubble"]) {
        const cartIconBubble = document.querySelector(".cart-count-bubble, [data-cart-count]")
        if (cartIconBubble) {
          const tempDiv = document.createElement("div")
          tempDiv.innerHTML = sectionsData["cart-icon-bubble"]
          const newBubble = tempDiv.querySelector(".cart-count-bubble, [data-cart-count]")
          if (newBubble) cartIconBubble.outerHTML = newBubble.outerHTML
        }
      }
    } catch {
      const cartDrawer = document.querySelector("cart-drawer")
      if (cartDrawer) {
        if (typeof cartDrawer.open === "function") cartDrawer.open()
        else {
          cartDrawer.classList.add("active")
          cartDrawer.setAttribute("open", "")
        }
      }
    }
  }

  // Asynchronous function to update the cart icon bubble with the current item count.
  async function updateCartIconBubble() {
    try {
      await new Promise((resolve) => setTimeout(resolve, 300))
      const cartResponse = await fetch("/cart.js?" + Date.now())
      if (cartResponse.ok) {
        const cartData = await cartResponse.json()
        const cartIconBubble = document.getElementById("cart-icon-bubble")
        if (cartIconBubble) {
          let countDiv = cartIconBubble.querySelector("div > span[aria-hidden]")
          if (cartData.item_count > 0) {
            if (!countDiv) {
              countDiv = document.createElement("div")
              countDiv.className = "max-[990px]:tw-self-end"
              cartIconBubble.appendChild(countDiv)
            }
            countDiv.innerHTML = `<span aria-hidden="true">(${cartData.item_count})</span><span class="visually-hidden">(${cartData.item_count} items)</span>`
          } else {
            if (countDiv) {
              countDiv.remove()
            }
          }
        }
      }
    } catch (error) {
      console.error("Error updating cart count:", error)
    }
  }

})();